import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Settings } from "../../store/reducers/AccountSlice";
import HeaderTenantTitle from "../HeaderTenantTitle/HeaderTenantTitle";
import { Icon } from "../Icon/Icon";
import { useEntryAnimation } from "../../hooks/useEntryAnimation";

type Props = {
  children: JSX.Element
  mobileMenuButton?: JSX.Element
};

function MenuContainer({children, mobileMenuButton}: Props) {
  
  const settings: Settings = useSelector((state: any) => state.settings.value);
  const isLoggedIn = useSelector((state: any) => state.settings.value.isLoggedIn);
  const navigate = useNavigate(); 
  const shouldAnimate = useEntryAnimation(100);

  const handleIconClick = () => {
    navigate('/');
  };

  // Default eAteliers logo for when not logged in or no logoUrl
  const defaultLogoUrl = '/logo192.png';

  return (
    <div className={`flex flex-col md:flex-row md:justify-between items-center p-2 md:p-3 px-1 md:px-7 md:top-0 md:sticky md:shadow-sm border-b border-gray-200 bg-card w-full m-0 z-20 ${shouldAnimate ? 'animate-slide-in-from-top-entry' : 'opacity-0'}`}>
      {/* Mobile: First row - Logo and Menu button */}
      <div className="flex items-center justify-between w-full md:w-auto md:justify-start px-4">
        <div className="flex items-center">
          { settings.logoUrl ? 
            <Icon url={settings.logoUrl} glyph={false} cssStyles="h-8 md:h-12 w-auto min-w-full max-w-full mr-2 md:mr-3" onClick={handleIconClick}/> 
          : isLoggedIn ? (
            <HeaderTenantTitle text={settings.tenantName || 'eAteliers'} onClick={handleIconClick}/>
          ) : (
            <div className="flex items-center cursor-pointer" onClick={handleIconClick}>
              <Icon url={defaultLogoUrl} glyph={false} cssStyles="h-6 md:h-8 w-16 md:w-20 mr-2" />
              <span className="text-xl md:text-2xl font-semibold text-slate-700">eAteliers</span>
            </div>
          )
          }
        </div>
        {/* Mobile menu button positioned here */}
        <div className="md:hidden">
          {mobileMenuButton}
        </div>
      </div>
      
      {/* Mobile: Second row - All other elements, Desktop: All elements in main row */}
      <div className="flex items-center justify-evenly md:justify-center flex-wrap space-x-2 md:space-x-5 w-full md:w-auto mt-1 md:mt-0">
        { children }
      </div>
    </div>
  );
}

export default MenuContainer;
